import { Link } from 'react-router-dom'
import { ArrowRight, Phone } from 'lucide-react'
import AnimatedSection from '@/components/AnimatedSection'

export default function CTASection() {
  return (
    <section className="bg-black py-24 text-white">
      <div className="section-padding mx-auto max-w-7xl">
        <AnimatedSection>
          <div className="grid gap-10 lg:grid-cols-[1fr_0.85fr] lg:items-center">
            <div>
              <span className="text-xs font-semibold uppercase tracking-[0.22em] text-accent">
                Start with certainty
              </span>
              <h2 className="mt-4 max-w-3xl text-3xl font-semibold leading-tight sm:text-4xl lg:text-5xl">
                Need a survey report your project team can rely on?
              </h2>
              <p className="mt-6 max-w-2xl text-sm leading-7 text-neutral-300">
                Share the site details and timeline. We will respond with the
                right scope, method, and next steps for your land or development
                requirement.
              </p>
              <div className="mt-9 flex flex-col gap-3 sm:flex-row">
                <Link to="/contact" className="btn-primary">
                  Request a Quote
                  <ArrowRight className="h-4 w-4" />
                </Link>
                <a href="tel:+2348034567890" className="btn-quiet-dark">
                  <Phone className="h-4 w-4" />
                  Call the Office
                </a>
              </div>
            </div>

            <div className="relative hidden lg:block">
              <img
                src="https://images.unsplash.com/photo-1503387762-592deb58ef4e?w=900&auto=format&fit=crop&q=85"
                alt="Surveying equipment on a construction project"
                className="h-[360px] w-full object-cover"
              />
              <div className="absolute bottom-0 left-0 bg-white px-6 py-5 text-black">
                <div className="text-2xl font-semibold">Fast scoping</div>
                <div className="mt-1 text-xs uppercase tracking-[0.18em] text-neutral-500">
                  Clear method. Clear fee. Clear timeline.
                </div>
              </div>
            </div>
          </div>
        </AnimatedSection>
      </div>
    </section>
  )
}
